export enum AllowedUrlParams {
  _ga = '_ga',
  _gid = '_gid',
  _gl = '_gl',
  gclid = 'gclid',
  utm_campaign = 'utm_campaign',
  utm_content = 'utm_content',
  utm_medium = 'utm_medium',
  utm_source = 'utm_source',
  utm_term = 'utm_term',
}

export const findAllowedURLParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const orderedParams = new URLSearchParams();

  for (const [param, value] of urlParams) {
    if (Object.values(AllowedUrlParams).includes(param as AllowedUrlParams)) {
      orderedParams.set(param, value);
    }
  }
  return orderedParams;
};
